import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import api from "../service/api";
import { setError } from "../reducers/appSlice";

const AutocompleteOrganismosSinAsignar = ({
  value,
  onChange,
  name,
  error = false,
  helperText = null,
  fullWidth = false,
  disabled = false,
  required = false,
  todos = false,
  label = "Organismos sin asignar",
}) => {
  const dispatch = useDispatch();
  const [searching, setSearching] = useState(true);
  const [datos, setDatos] = useState([]);
  const [seleccionado, setSeleccionado] = useState(null);

  useEffect(() => {
    setSearching(true);
    api
      .obtenerOrganismosSinAsignarAutocomplete()
      .then((res) => setDatos(res.data))
      .catch((e) => dispatch(setError(e.response?.data?.error)))
      .finally(() => setSearching(false));
  }, []);

  useEffect(() => {
    if (!value || !datos) return;
    const item = datos.find((item) => item.value === value);
    if (item) setSeleccionado(item);
  }, [value, datos]);

  return (
    <Autocomplete
      id={name}
      name={name}
      variant="outlined"
      size="small"
      margin="dense"
      fullWidth
      value={seleccionado}
      onChange={(e, item) => onChange(item.value)}
      options={datos}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
          disabled={searching || disabled}
        />
      )}
    />
  );
};

export default AutocompleteOrganismosSinAsignar;
